import { ProductDetails } from "@/@types";
import { transformProductImageGallery } from "@/helpers/products/transformProductImageGallery";

type ProductProps = {
    product: ProductDetails;
};

export default function ProductsInfoGeneralLG({ product }: ProductProps) {

    if (!product) {
        return (
            <div>
                <p>No product available or invalid product slug.</p>
            </div>
        );
    }
    const images = transformProductImageGallery(product.contents.images);

    return (
        <div className="hidden lg:flex xl:hidden">
        <div className="container">
            <div className="px-2 py-4">
                <h2 className="text-lg font-bold text-gray-800 py-0">
                    INFORMACIÓN GENERAL
                </h2>
                <div
                    className="text-sm text-gray-600 pb-1"
                    dangerouslySetInnerHTML={{ __html: product.short_description }}
                />
            </div>
        </div>
    </div>
    )
}
